"use client";

import { useEffect, useState } from "react";

export const DISABLE_DRAWER_ANIMATION_CLASS =
  "animate-none! transition-none! duration-0! data-[state=closed]:animate-none! data-[state=open]:animate-none!";

export function useDisableInitialDrawerAnimation(delayMs = 100) {
  const [isAnimationDisabled, setIsAnimationDisabled] = useState(true);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setIsAnimationDisabled(false);
    }, delayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs]);

  return isAnimationDisabled;
}
